import { useRef } from "react";

const usePreventRageClick = (asyncHandlerReference) => {
  const isPending = useRef(false);

  if (isPending.current) return;

  return async () => {
    isPending.current = true;
    let res;
    try {
      res = await asyncHandlerReference();
    } finally {
      isPending.current = false;
    }

    return res;
  };
};

export default usePreventRageClick;
